import locales from "./ko_locales";

export default {
    whalespace: "웨일 스페이스",
    help: "고객센터",
    locales,
    app: {
        name: "웨일 스페이스 개발자센터"
    },
    breadcrumb: "페이지 이동 경로",
    page: {
        home: "홈",
        guide: "가이드",
        developerRegister: "개발자 등록",
        apps: "애플리케이션",
        appRegister: "애플리케이션 등록",
        project: "프로젝트",
        projectJoin: "프로젝트 가입 요청",
        projectRegister: "프로젝트 생성"
    },
    sidebar: {
        project: "프로젝트",
        projectRegister: "새 프로젝트"
    },
    email: "이메일",
    login: "로그인",
    whale_lab: { title: "연구소" },
    notices: { title: "공지사항" },
    links: {
        terms: "이용약관",
        privacy: "개인정보 처리방침",
        privacy_whale: "Naver Whale 개인정보 보호를 위한 백서",
        help_naver: "고객센터",
        copyright_old: "\u{a9} NAVER Corp.",
        copyright: "\u{a9} NAVER Corp.",
        whale: "웨일 브라우저",
        download: "다운받기",
        whale_download_mo: "다운로드"
    },
    menus: {
        profile: {
            register: "개발자 등록",
            setting: "계정설정",
            unregister: "개발자 센터 탈퇴",
            delete: "개발자 탈퇴",
            logout: "로그아웃"
        }
    },
    home: {

        /*
         * 개행문자는 항목/환경에 따라 white-space: pre-line으로 렌더링됩니다.
         * - title : 모바일 환경
         * - desc : pc/태블릿 환경
         * - items : pc/태블릿/모바일 환경
         */
        title: "웨일 스페이스 개발자센터\n서비스 지원 종료 안내",
        desc: "웨일 스페이스 개발자센터 서비스 지원이 올해 하반기 이 후 종료됨에 따라\n이용자 분들께 사전 고지 드립니다.\n\n기존에 사용중인 기능은 새롭게 제공되는 App Console을 통해 제공될 예정입니다.\n구체적인 종료 시점에 대한 내용은 공지사항에서 확인하실 수 있습니다.",
        appConsoleShortcut: "App Console 바로가기",
        appConsoleRequest: "App Console 권한 신청",
        noticeShortcut: "공지사항 바로가기",
        obsolete: "지원종료",
        deprecated: "지원종료 예정",
        items: {
            guide: {
                title: "개발자 가이드",
                desc: `웨일 스페이스 애플리케이션 등록을 위한 
                가이드를 확인해 보세요.`
            },
            api: {
                title: "웨일 스페이스 API",
                desc: `웨일 스페이스에서 활용할 수 있는 API를 
                확인해 보세요.`
            },
            lab: {
                title: "연구소",
                desc: `웨일 스페이스 애플리케이션 개발 비법, 
                어려움을 함께 나눠보세요.`
            }
        }
    },
    appConsole: {
        title: "App Console 권한 요청",
        request: {
            title: "App Console 권한 요청",
            subTitle1:
                "App Console 권한 신청 개발사는 교육 서비스 플랫폼인 웨일 스페이스를 이용 중인 기관에서 개발사의 서비스를\n 웨일 스페이스 계정으로 이용할 수 있도록 로그인 연동 개발을 희망하는 개발사입니다. (웨일 스페이스로 로그인)",
            subTitle2:
                "개발사의 서비스는 교육용 서비스로 한정하며 신청 단계에서 웨일 스페이스 관리자가 확인 후 승인 단계를 필수로\n 거치게 됩니다.",
            normalInfo: {
                title: "기관 정보",
                companyTitle: "회사명",
                companyPlaceholder: "웨일 개발사",
                companyError: "회사명을 입력해주세요",
                phoneTitle: "회사 전화번호",
                phonePlaceholder: "번호만 입력해주세요",
                phoneError: "회사 전화번호를 입력해주세요",
                domainTitle: "회사 홈페이지",
                domainPlaceholder:
                    "http, https 정보는 제외하고 등록해주세요 (예시. naver.com)",
                domainError: "회사 홈페이지를 입력해주세요",
                domainWrongError: "정확한 도메인명을 입력해주세요 (예) aaa.com",
                industrySizeTitle: "업종 및 규모",
                industryList: [
                    "공공기관",
                    "마케팅/광고/미디어 ",
                    "비영리 기관",
                    "정보통신/IT",
                    "학교 및 교육 서비스",
                    "기타"
                ],
                sizeList: [
                    "1명",
                    "2~9명",
                    "10~19명",
                    "20~49명",
                    "50~99명",
                    "100~299명",
                    "300명 이상"
                ]
            },
            personInfo: {
                title: "신청자 정보",
                nameTitle: "성/이름",
                lastNamePlaceholder: "홍",
                firstNamePlaceholder: "길동",
                emailTitle: "이메일",
                emailPlaceholder: "aaa@bbb.com",
                phoneTitle: "휴대전화번호",
                phonePlaceholder: "번호만 입력해주세요"
            },
            serviceInfo: {
                title: "서비스 정보",
                serviceTitle: "서비스 명",
                servicePlaceholder: "웨일그리기도구",
                introTitle: "서비스 소개",
                introPlaceholder:
                    "서비스에 대한 기능을 확인할 수 있는 사이트 링크 혹은\n간략한 소개 내용이 있다면 적어주세요.",
                targetDetailsTitle: "기관 정보",
                targetDetailsContent:
                    "개발사가 '웨일 스페이스 로그인'을 적용하려는 서비스는 특정 교육청이나 기관을 대상으로 합니까? 해당한다면, 대상 기관 정보를 입력해주세요.",
                targetDetailsPlaceholder: "답변을 입력해주세요.",
                homepageDisplayTitle: "홈페이지 노출",
                homepageDisplayContent:
                    "웨일 스페이스 홈페이지 > 제휴서비스 페이지에 노출을 희망하십니까?",
                homepageDisplaySubcontent:
                    "https://whalespace.io/services 를 통해 웨일 스페이스 연동 개발된 3rd party 서비스를 안내하고 있습니다. 특정 기관 사용자만을 대상으로 하는 서비스라면 노출에 적절하지 않을 수 있습니다.",
                targetTimelineTitle: "목표 일정",
                targetTimelineContent:
                    "예상하시는 또는 목표하시는 '웨일 스페이스 로그인' 적용 일정을 알려주세요.",
                targetTimelinePlaceholder: "(예시 2025.02.08)"
            },
            privacy: {
                title: "개인정보 수집 및 이용 안내",
                descList: [
                    "개인정보 보호법 제15조제1항제4호(계약이행)에 따라 아래의 개인정보를 수집·이용합니다.",
                    "<br>",
                    "1. 개인정보의 수집 목적 : 웨일 스페이스 App Console 계정 생성 및 개발자 권한 등록",
                    "2. 수집하는 개인정보의 항목 : 이름, 이메일 주소, 휴대전화 번호",
                    "3. 개인정보의 보유 및 이용기간 : App Console 탈퇴 시까지",
                    "<br>",
                    "자세한 사항은 <a href='https://policies.whale.naver.com/ko/whalespace-privacy'>웨일 스페이스 개인정보처리방침</a>을 참고 하시기 바랍니다."
                ]
            },
            submit: "등록요청"
        },
        complete: {
            title: "등록이 완료되었습니다!",
            subTitle:
                "등록된 정보 내부에서 검토 후 신청자 정보에 입력하신 이메일 정보로 전달드릴 예정입니다.",
            normalInfo: {
                title: "기관 정보",
                companyTitle: "회사명",
                phoneTitle: "회사 전화번호",
                domainTitle: "회사 홈페이지",
                industrySizeTitle: "업종 및 규모"
            },
            personInfo: {
                title: "신청자 정보",
                nameTitle: "성/이름",
                emailTitle: "이메일",
                phoneTitle: "휴대전화번호"
            },
            serviceInfo: {
                title: "서비스 정보",
                serviceTitle: "서비스 명",
                introTitle: "서비스 소개",
                targetDetailsTitle: "기관 정보",
                homepageDisplayTitle: "홈페이지 노출",
                targetTimelineTitle: "목표일정"
            },
            submit: "홈페이지로 바로가기"
        }
    },
    guides: {
        versions: {
            loginApi1: "v1.0 (2022년 12월까지 제공)",
            loginApi2: "v1.1"
        },
        deprecated: {
            text1: "로그인 API v1.0은 2024년 8월 16일자로 지원 종료되었습니다.",
            text2: "로그인 API v1.1",
            text3: "로 전환이 필요합니다."
        }
    },
    welcome: {
        title: "웨일 개발자센터 가입을 환영합니다!",
        desc: "웨일스페이스 개발자센터 가입이 완료되었습니다. \n개발자로 등록하시면 애플리케이션 관리 및 API 설정을 할 수 있습니다."
    },
    agreement: {
        title: "이용약관 및 개인정보 수집 동의",
        agreedAll: "전체 약관에 동의합니다.",
        service: {
            title: "서비스 이용 약관 동의 (필수)",
            agree: "이용 약관을 읽었으며 이에 동의합니다."
        },
        privacy: {
            title: "개인정보 수집 및 이용 동의 (필수)",
            items: [
                "수집하는 개인 정보의 항목 : (필수) 이메일 주소, 프로필 사진, 출생연도, 생일",
                "개인 정보의 수집, 이용 목적 : 애플리케이션의 스토어 등록 시 개발자 정보 표시 및 공개, 스토어 관리 및 운영을 위해 필요한 고지 및 안내",
                "개인 정보의 보유 및 이용 기간 : 서비스 이용 기간 동안 보관",
                `정보주체는 개인 정보 수집 및 이용 동의를 거부할 권리가 있습니다. 다만 개인 정보 수집 및 이용 동의를 거부하실 경우, 
                가입 요청하신 서비스 이용이 제한되거나 불가할 수 있습니다.`
            ],
            agree: "개인정보 수집 및 이용 동의를 읽었으며 이에 동의합니다."
        },
        account: {
            helper: "네이버 회원정보의 연락처 이메일이 네이버 메일이 아닐 경우 정상적인 서비스 이용이 불가합니다. 이메일을 확인해 주세요.",
            link: "회원정보 바로가기"
        }
    },
    label: {
        confirm: "확인",
        cancel: "취소",
        register: "등록",
        add: "생성",
        save: "저장",
        delete: "탈퇴",
        remove: "삭제",
        approve: "승인",
        reject: "거절",
        join: "가입 요청",
        copy: "복사",
        publish: "발행",
        republish: "재발행",
        add_member: "개발자 추가",
        change_admin: "관리자 변경",
        unregister: "프로젝트 가입 요청 취소",
        delete_project: "프로젝트 삭제",
        withdrawProject: "프로젝트 탈퇴",
        registerDeveloper: "개발자 등록",
        main: "홈페이지 메인"
    },
    apps: {
        emptyTable: "등록된 애플리케이션이 없습니다.",
        fieldName: {
            clientName: "애플리케이션",
            clientId: "Client ID",
            status: "상태",
            type: "유형"
        },
        status: {
            WAIT_APPROVAL: "등록 승인 대기 중",
            APPROVAL: "등록 승인",
            REJECT_APPROVAL: "등록 승인 반려",
            WAIT_UPDATE: "업데이트 대기 중",
            REJECT_UPDATE: "업데이트 반려",
            HOMEPAGE_DEPLOYED: "홈페이지 배포"
        },
        type: {
            WEB_APP: "웹 애플리케이션",
            ANDRIOD: "안드로이드",
            IOS: "iOS",
            DESKTOP_APP: "데스크톱 앱"
        },
        labels: {
            registerApp: "애플리케이션 등록"
        }
    },
    appRegister: {
        guide: {
            register: "작성해주신 내용을 바탕으로 등록 심사 절차를 진행합니다.",
            WAIT_APPROVAL:
                "작성해주신 내용을 바탕으로 등록 심사 절차를 <em>진행중</em>입니다.",
            REJECT_APPROVAL: "애플리케이션 등록이 <em>반려</em>되었습니다.",
            REJECT_UPDATE: "업데이트 <em>반려</em>되었습니다.",
            REJECT_MESSAGE: "(반려사유: {statusMessage})"
        },
        cancelRegister: {
            title: "애플리케이션 등록 취소",
            content: "입력하신 내용이 모두 삭제됩니다."
        },
        saveRegister: {
            title: "애플리케이션 등록",
            content:
                "입력하신 내용을 바탕으로 애플리케이션 등록 심사를 진행합니다. 애플리케이션을 등록하시겠습니까?"
        },
        label: {
            delete: "삭제",
            edit: "정보 수정",
            reRegister: "재등록"
        }
    },
    appDetail: {
        tabs: {
            overview: "개요",
            information: "홈페이지 노출 정보",
            api: "API",
            customers: "적용기관"
        },
        label: {
            uploadImage: "이미지 등록",
            update: "업데이트 요청",
            cancelUpdate: "업데이트 요청 취소",
            required: "필수 입력 사항",
            optional: "선택 입력 사항",
            default: "기본",
            defaultLanguage: "기본 언어",
            defaultLanguageSetting: "기본 언어 설정"
        },
        fieldName: {
            status: "애플리케이션 상태",
            clientName: "애플리케이션 이름",
            redirectUri: "Redirect URI",
            clientId: "Client ID",
            clientSecret: "Client Secret",
            apiKey: "API key",
            description: "한줄 소개",
            categories: "카테고리",
            project: "프로젝트 이름",
            companyUrl: "개발사 URL",
            serviceUrl: "서비스 URL",
            serviceInfoUrl: "서비스 소개 URL",
            servicePrice: "서비스 요금정책",
            version: "버전 정보",
            explanation: "상세 설명",
            iconUrl: "아이콘 이미지",
            serviceImageUrl: "대표 이미지",
            offeredData: "API 제공정보",
            languages: "홈페이지 노출 언어 설정",
            availableLanguages: "제공 언어",
            selectLanguage: "언어 선택"
        },
        placeholder: {
            clientName: "애플리케이션 이름을 입력해 주세요.",
            description: "한줄 소개를 입력해 주세요.",
            companyUrl: "개발사 URL을 입력해 주세요.",
            serviceUrl: "서비스 URL을 입력해 주세요.",
            serviceInfoUrl: "서비스 소개 URL을 입력해 주세요.",
            categories: "카테고리를 선택해 주세요.",
            project: "프로젝트 이름을 선택해 주세요.",
            servicePrice: "요금정책을 선택해 주세요.",
            version: "버전 정보를 입력해 주세요.",
            explanation: "상세설명을 입력해 주세요.",
            languages: "언어 검색"
        },
        categoriesGuide: "최대 3개까지 중복선택 가능",
        imageGuide: "권장 이미지 사이즈: {0}px * {1}px / gif, png, jpg(jpeg)",
        imageCountGuide: " / 최대 6장",
        informationGuide:
            "애플리케이션 심사 후 제휴서비스 페이지에 업로드 됩니다.",
        informationSample: "샘플보기",
        languagesGuide:
            "홈페이지에 노출되는 언어를 설정하고 언어별 제휴 서비스 내용을 입력할 수 있습니다. 브라우저 언어와 동일할 경우 최우선으로 제공되며, 브라우저 언어와 일치한 언어가 없을 경우 기본 언어로 설정한 언어가 노출됩니다.",
        requiredFieldsGuide:
            "선택한 모든 언어의 필수 입력 영역을 모두 등록해 주세요.",
        clientSecret: {
            show: "보기",
            hide: "숨기기",
            reissuance: "재발급"
        },
        changeDefaultLanguage: {
            title: "기본 언어 설정",
            content: "기본 언어를 변경하시겠습니까?"
        },
        api: {
            access: "권한",
            required: "필수",
            optional: "선택",
            offeredData: {
                guide: "계정 ID 기본 제공",
                tempGuide:
                    "제공 정보의 필수, 선택 설정은 추후 제공될 예정입니다.",
                title: {
                    name: "이름",
                    thumbnailPhotoUrl: "프로필 이미지",
                    userType: "사용자 구분",
                    space: "소속 기관 정보",
                    userOrgunits: "소속 조직 정보",
                    number: "고유 번호",
                    relation: "관계 정보"
                },
                detail: {
                    userType: "직급",
                    space: "교육청, 학교",
                    userOrgunits: "학년, 반",
                    number: "번호"
                }
            },
            addRedirectUri: "Redirect URI 추가",
            cancelRedirectUri: {
                title: "Redirect URI 취소",
                content: "입력하신 내용이 모두 삭제됩니다."
            },
            emptyRedirectUri: {
                title: "Redirect URI",
                content:
                    "입력된 Redirect URI가 없습니다. Redirect URI를 입력해 주세요."
            },
            saveRedirectUri: "Redirect URI가 저장되었습니다."
        },
        information: {
            cancelInformation: {
                title: "업데이트 취소",
                content: "홈페이지 노출 정보에 입력하신 내용이 모두 삭제됩니다."
            },
            saveInformation: {
                title: "업데이트 요청",
                content:
                    "입력하신 내용을 바탕으로 애플리케이션 심사 진행 후 제휴 서비스 페이지에 업데이트합니다. 업데이트를 요청하시겠습니까?"
            },
            invalidInputFields: {
                title: "업데이트 요청",
                content:
                    "각 언어별 필수 입력사항을 모두 입력해주셔야 합니다.\n다시 한번 확인해주세요."
            }
        },
        servicePrice: {
            PAID: "유료",
            FREE: "무료",
            PARTIAL_PAID: "부분유료"
        },
        deleteApplication: {
            title: "애플리케이션 삭제",
            content:
                "애플리케이션을 삭제합니다. 삭제된 애플리케이션은 복구할 수 없습니다."
        },
        customers: {
            guide: "애플리케이션을 제공할 기관을 설정합니다.\n설정된 기관 정보를 따라 웨일 스페이스 홈페이지의 {0} 메뉴 및 해당 기관의 웨일 스페이스 관리자 페이지에 노출됩니다.",
            link: "제휴 서비스",
            notice: {
                title: "확인해 주세요!",
                content:
                    "설정 기관을 대상으로 애플리케이션 노출 유무만 제어합니다. 타 기관 사용자(도메인)의 애플리케이션 접근은 차단할 수 없습니다."
            },
            type: {
                EDU_OFF: "교육청",
                EDU_KND: "유치원",
                EDU_ELEM: "초등학교",
                EDU_MS: "중학교",
                EDU_HS: "고등학교",
                EDU_UNIV: "대학교",
                EDU_OTHER: "교육 기타",
                EDU: "교육",
                CORP: "기업"
            },
            allCustomerType: "기관 전체",
            list: "기관 목록",
            table: {
                header: {
                    unSelected: "기관",
                    selected: "적용된 기관 ({count})"
                },
                empty: {
                    unSelected: "전체 기관에 애플리케이션이\n 적용되었습니다.",
                    selected: "적용된 기관이 없습니다.\n 기관을 선택해 주세요."
                }
            },
            cancelUpdate: {
                title: "기관 적용 취소",
                content: "적용하신 내용이 모두 삭제됩니다."
            },
            notModified: {
                title: "적용기관 저장",
                content: "적용된 기관이 없습니다. 기관을 선택해 주세요."
            },
            saveUpdate: "기관이 저장되었습니다."
        }
    },
    projects: {
        fieldName: {
            name: "프로젝트 이름",
            appCount: "애플리케이션",
            status: "상태"
        },
        appCount: "{0}개",
        status: {
            USER: "개발자",
            ADMIN: "관리자",
            WAIT_APPROVAL: "승인 대기 중"
        },
        emptyMessage: "프로젝트가 없습니다.",
        actions: {
            register: "프로젝트 생성",
            join: "프로젝트 가입 요청"
        }
    },
    project: {
        tabs: {
            "overview": "개요",
            "apps": "애플리케이션",
            "service-accounts": "서비스 계정",
            "account": "테스트 계정"
        },
        name: {
            title: "프로젝트 이름",
            placeholder: "프로젝트 이름을 입력해 주세요."
        },
        code: {
            title: "프로젝트 코드",
            placeholder: "코드를 입력해 주세요.",
            info: "웨일 스페이스 테스트 계정 관리를 위한 코드로 6~13자 이내의 영문, 숫자, 기호(-)와(_)로 구성된 코드를 입력해 주세요."
        },
        register: {
            empty_search: "프로젝트가 없습니다."
        },
        admin: {
            title: "관리자",
            helper: "관리자는 삭제할 수 없습니다."
        },
        members: {
            title: "개발자",
            placeholder: "네이버 계정을 입력해 주세요."
        },
        add_member: {
            helper: "네이버 아이디로 등록 가능합니다."
        },
        wait_approval: {
            title: "개발자 등록 요청"
        },
        pending: {
            title: "프로젝트 가입 요청이 완료되었습니다.",
            des: "<em>{projectName}</em>의 관리자 승인을 대기 중입니다."
        },
        updateInfo: {
            save: "프로젝트 정보가 변경되었습니다.",
            cancel: {
                title: "저장 확인",
                content: `저장하지 않은 정보가 있습니다. 
                계속 진행하시겠습니까?`
            }
        },
        account: {
            desc: "웨일 스페이스 관리자용 계정을 발급받아 웨일 스페이스 Admin에서 자유롭게 테스트 계정을 생성할 수 있습니다.",
            howToUse: "웨일 스페이스 Admin 사용방법 안내",
            howToUseShortcut: "바로가기",
            adminShortcut: "웨일 스페이스 Admin 바로가기",
            confirm:
                "웨일 스페이스 테스트 용도로만 사용하며, 테스트 중 발생한 문제에 대해서는 당사가 책임을 부담하지 않습니다.",
            create: "웨일 스페이스 관리자용 계정 발급",
            id: "아이디",
            password: "비밀번호",
            forgotPassword: "비밀번호를 잊으셨나요?"
        },
        error: {
            register: {
                DUPLICATED_LABEL_NAME:
                    "동일한 이름의 프로젝트가 존재합니다. 다른 이름으로 입력해 주세요.",
                DUPLICATED_NAME: "이미 사용 중인 코드입니다."
            },
            join: {
                DUPLICATED_LABEL_NAME: "이미 가입된 프로젝트 입니다."
            }
        }
    },
    serviceAccounts: {
        scope: {
            "admin.directory.space.readonly": "스페이스/학교 목록 및 상세 조회",
            "admin.directory.orgunit.readonly": "조직 목록 및 상세 조회",
            "admin.directory.user.readonly": "사용자 목록 조회",
            "admin.directory.device.readonly": "기기 목록 조회",
            "admin.directory.browser.readonly": "관리 브라우저 목록 조회",
            "admin.directory.space": "스페이스/학교 목록 및 수정",
            "admin.directory.orgunit": "조직 목록 및 수정",
            "admin.directory.user": "사용자 목록 및 정보 수정",
            "admin.directory.device": "기기 목록 및 정보 수정",
            "admin.directory.browser": "관리 브라우저 목록 및 정보 수정"
        },
        scopePostfix: " 외 {0}건",
        fieldName: {
            account: "서비스 계정",
            clientId: "Client ID",
            clientSecret: "Client Secret",
            apiKey: "API key",
            customer: "기관",
            scope: "권한 제공 범위",
            accountName: "서비스 이름",
            privateKey: "비밀 키"
        },
        emptyTable: "서비스 계정이 없습니다.",
        labels: {
            createAccount: "서비스 계정 생성",
            deleteAccount: "서비스 계정 삭제",
            list: "목록"
        },
        placeholder: {
            account: "서비스 계정을 입력해주세요.",
            accountName: "서비스 이름을 입력해주세요.",
            privateKey: "비밀 키는 계정 생성 후 발급 받을 수 있습니다."
        },
        tooltip: {
            account:
                "서비스 계정은 영문, 숫자로만 등록이 가능하며, 등록 후 수정이 불가능합니다."
        },
        create: {
            title: "서비스 계정 생성불가",
            content:
                "서비스 지원 종료로 인해 신규 서비스계정 생성이 불가능합니다.",
            description:
                "관련 문의는 dl_whalespace_devcenter@navercorp.com 메일로 문의 부탁드립니다."
        },
        delete: {
            title: "서비스 계정 삭제",
            description:
                "서비스 계정 삭제 시 해당 계정으로 제공되던 기관 정보와 접근 권한이 모두 삭제됩니다. 삭제하시겠습니까?"
        },
        privateKey: {
            title: "비밀 키 발행",
            description:
                "비밀 키는 서버 인증 시 중요한 파일이니 외부로 유출되지 않도록 유의해 주세요. 발행 후에는 같은 키로 발급이 되지 않으며 재발행시에는 기존에 사용하던 키를 사용할 수 없습니다.\n\n'확인' 을 누르면 비밀 키가 담긴 파일이 다운로드 됩니다."
        }
    },
    deleteAccount: {
        title: "웨일 스페이스 개발자 탈퇴",
        content: {
            admin: "탈퇴 시 등록된 개인 정보(이메일 주소, 프로젝트 이름)가 삭제되며, 애플리케이션 등록, 수정, 업데이트가 불가합니다. 동의 철회 시 아래 안내 사항을 먼저 확인하여 주세요.",
            developer:
                "탈퇴 시 등록된 개인 정보(이메일 주소, 프로젝트 이름)가 삭제되며, 애플리케이션 등록, 수정, 업데이트가 불가합니다. 삭제된 계정은 다시 복구할 수 없습니다.",
            undeletable:
                "등록하신 모든 애플리케이션 및 프로젝트에 속한 개발자 정보 삭제 또는 관리자를 타 사용자로 변경하신 후 탈퇴가 가능합니다."
        },
        notice: [
            "개인 정보 제공 및 이용 동의 철회는 등록하신 모든 애플리케이션 및 프로젝트에 속한 개발자 정보가 삭제된 상태에서 가능합니다.",
            "동의 철회 시 기존 애플리케이션 등록 이력은 철회 요청 익일 모두 삭제됩니다.",
            "삭제된 계정은 다시 복구할 수 없고 계정에 귀속된 애플리케이션 관련 정보들도 모두 완전히 삭제됩니다."
        ],
        confirm: {
            admin: "동의 철회 시 위의 안내 사항을 모두 확인하였습니다.",
            developer: "안내 사항을 모두 확인하였습니다."
        }
    },
    reissueClientSecret: {
        title: "Client Secret 재발급",
        content:
            "현재 키를 삭제하고 재발급합니다. 기존 키는 더 이상 사용할 수 없습니다."
    },
    changeAdmin: {
        title: "관리자 변경",
        content:
            "선택한 개발자에게 관리자 권한을 이양합니다. 이양된 관리자 권한은 다시 회수할 수 없습니다.",
        select: "선택",
        developer: "개발자"
    },
    deleteProject: {
        title: "프로젝트 삭제",
        undeletable: `등록하신 모든 애플리케이션 및 프로젝트에 속한 개발자 정보
        삭제 후 프로젝트 삭제가 가능합니다.`,
        content: "프로젝트 ‘{projectName}’을 삭제하시겠습니까?"
    },
    withdrawProject: {
        title: "프로젝트 탈퇴",
        content: "프로젝트 ‘{projectName}’에서 탈퇴하시겠습니까?"
    },
    invalidLoginInfo: {
        title: "계정 제공 정보 확인",
        content:
            "개발자센터 이용을 위해서는 아래 정보의 필수 제공 동의가 필요합니다.",
        data: {
            title: "필수 제공 항목",
            content: "이메일 주소, 프로필 사진"
        },
        detail: "네이버 내정보의 ‘{0}’ 페이지에서 연동을 철회하시면 정보 제공 동의 절차를 다시 수행하실 수 있습니다.",
        link: "네이버와 연결된 서비스 관리"
    },
    news: {
        title: "웨일 스페이스 개발자센터 이용 약관 변경 안내",
        content: "",
        detail: `웨일 스페이스 개발자센터 이용약관이 2023년 5월 1일 자로 변경 적용될 예정입니다. 이에 따라 현재 적용 중인 이용 약관은 개정일을 기준으로 새로운 이용 약관으로 대체됩니다.
        
        변경되는 주요 사항은 아래 링크를 통해서 확인하실 수 있습니다.`,
        button: "변경 사항 자세히 보기"
    },
    error: {
        email: "이메일 주소를 확인해 주세요.",
        projectName: "프로젝트 이름을 확인해 주세요.",
        appName: "중복된 애플리케이션 이름입니다. 이름을 확인해 주세요.",
        imageCount: "대표 이미지는 최대 6장까지 등록 가능합니다.",
        unknown: "알 수 없는 오류입니다.",
        valueMissing: {
            projectName: "프로젝트 이름은 필수 항목입니다.",
            projectCode: "프로젝트 코드는 필수 항목입니다.",
            accountName: "서비스 이름은 필수 항목입니다.",
            account: "서비스 계정은 필수 항목입니다.",
            acCompany: "회사명을 입력해주세요",
            acCompanyPhoneNumber: "회사 전화번호를 입력해주세요",
            acDomain: "도메인을 입력해주세요",
            acLastname: "성을 입력해주세요",
            acFirstname: "이름을 입력해주세요",
            acEmail: "이메일 정보를 입력해주세요",
            acServiceName: "서비스 명을 입력해주세요",
            acServiceDesc:
                "서비스를 더 자세하게 확인할 수 있는 정보를 입력해주세요",
            acPhone: "휴대전화번호를 입력해주세요",
            acTargetDetails: "기관 정보를 입력해주세요.",
            acTargetTimeline: "일정을 입력해주세요"
        },
        patternMismatch: {
            projectName:
                "프로젝트 이름에 사용할 수 없는 특수 문자가 포함되어 있습니다.",
            projectCode:
                "코드(ID)는 6~13자 이내 영문, 숫자, 기호(-)와 (_)만 사용하세요.",
            account: "서비스 계정은 영문, 숫자만 사용하세요.",
            acDomain: "정확한 도메인명을 입력해주세요",
            acEmail: "정확한 이메일을 입력해주세요",

            acFirstname: "사용할 수 없는 특수 문자가 포함되어 있습니다.",
            acLastname: "사용할 수 없는 특수 문자가 포함되어 있습니다."
        },
        alreadyInUse: {
            name: "해당 이름은 사용 중입니다.",
            account: "해당 계정은 사용 중입니다."
        },
        INVALID_PROJECT_CODE: "프로젝트 코드가 유효하지 않습니다.",
        DUPLICATED_NAME: "이미 사용 중인 이름입니다",
        TERMS_AGREE: "약관 동의를 해주세요"
    },
    alertCreate: {
        project: {
            title: "프로젝트 생성 불가",
            content:
                "서비스 지원 종료로 인해 신규 프로젝트 생성이 불가능합니다.\n\n관련 문의는 dl_whalespace_devcenter@navercorp.com 메일로 문의 부탁드립니다."
        },
        application: {
            title: "애플리케이션 등록 불가",
            content:
                "서비스 지원 종료로 인해 신규 애플리케이션 등록이 불가능합니다.\n\n관련 문의는 dl_whalespace_devcenter@navercorp.com 메일로 문의 부탁드립니다."
        }
    }
};
